import types from './InventoryItemStatusType';

/**
 * Цвета статусов оборудования для точек в строке счётчиков.
 *
 * Разбиты по смыслу, а не по палитре: «в норме» зелёное, «ждёт действия» тёплое,
 * «требует вмешательства» красное, «выбыло» серое. Так строка читается с одного взгляда,
 * не вчитываясь в подписи.
 *
 * Значения захардкожены так же, как в RequestStatusColor: токенов под статусные цвета
 * в проекте нет, и заводить первый ради одного модуля не стоит.
 */
export default class InventoryItemStatusColor {
    static [types.IN_STOCK] = '#2f80ed';
    static [types.RESERVED] = '#f2994a';
    static [types.IN_USE] = '#1ca75e';
    static [types.IN_REPAIR] = '#f2c94c';
    static [types.BROKEN] = '#e53935';
    static [types.DECOMMISSIONED] = '#9aa0a6';
}
